<template>
  <v-col>
    <v-autocomplete
      :items="trainDeviationTypes"
      :rules="[required]"
      item-value="key"
      item-text="name"
      outlined
      label="Avvikelsetyp"
      v-model="deviation_type"
    />
  </v-col>
</template>

<script>
import { sync } from 'vuex-pathify'
import trainDeviationTypes from '@/common/trainDeviationTypes'
import { required } from '@/common/validationRules'

export default {
  name: 'TrainDeviationDeviationTypeField',

  data: () => ({
    required,
    trainDeviationTypes: Object.keys(trainDeviationTypes)
      .map(key => ({
        key,
        name: trainDeviationTypes[key]
      }))
      .filter(x => x.key !== 'CANCELED_STOP')
  }),

  computed: {
    deviation_type: sync('trainDeviation/model@deviation_type')
  }
}
</script>
